import {user} from "@/functions/user";
import {generateRandomString, falseCaptcha} from "@/functions/generateRandomString";
import { hCaptchaLoader } from '@hcaptcha/loader';

// hcaptcha.render() throws "Only one captcha is permitted per parent container"
// if the same element is rendered twice, so a retry must reuse the widget.
const renderedWidgets = new WeakMap()

const getHCaptcha = () => {
    const hCaptchaSiteKey = process.env.VUE_APP_HCAPTCHA_SITEKEY
    const callCaptcha = async (captchaId) => {
        const captchaElement = document.getElementById(captchaId)
        const disableCaptcha = sessionStorage.getItem('disable_captcha') === 'true'
        if (typeof hCaptchaLoader !== 'undefined' && !disableCaptcha) {
            return await hCaptchaLoader().then(async () => {
                let widgetId = renderedWidgets.get(captchaElement)
                if (widgetId === undefined) {
                    widgetId = hcaptcha.render(captchaElement, {
                        sitekey: hCaptchaSiteKey
                    });
                    renderedWidgets.set(captchaElement, widgetId)
                }
                else {
                    hcaptcha.reset(widgetId)
                }
                return await hcaptcha.execute(widgetId, { async: true });
            }).then(captcha => {
                if (captcha.response) {
                    user.captcha = captcha.response
                    return true
                } else {
                    return false
                }
            }).catch(() => {
                user.captcha = generateRandomString(64) + falseCaptcha
                return true
            })
        } else {
            user.captcha = generateRandomString(64) + falseCaptcha
            return true
        }
    }

    return {
        hCaptchaSiteKey,
        callCaptcha
    }
}
export default getHCaptcha